import React from 'react';

import { ReactComponent as InfoIcon } from '@pkg/assets/icons/v2/info.svg';

import './_InformationBanner.scss';

interface YatInformationBannerProps {
    copy: string;
}

export const YatInformationBanner = ({ copy }: YatInformationBannerProps) => {
    return (
        <div className="yat-information-banner">
            <InfoIcon className="yat-information-banner__icon" />
            <p className="yat-information-banner__copy v2-text-fluid-sm">{copy}</p>
        </div>
    );
};
